import axios from '@/plugins/axios';

const initialState = {
  list: [],
};

const actions = {
  async fetchList({ commit }) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      const { data } = await axios.get('weekend_schedule', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      commit('setList', data.data.items);

      return data;
    } catch (error) {
      return error;
    }
  },

  async addNew(_, params) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.post('weekend_schedule', params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },

  async updateItem(_, { id, params }) {
    try {
      const lang = localStorage.getItem('language') || '';
      const token = localStorage.getItem('token') || '';
      await axios.put(`weekend_schedule/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
